import { render, staticRenderFns } from "./SaveDesign.vue?vue&type=template&id=2544c040"
import script from "./SaveDesign.vue?vue&type=script&lang=js"
export * from "./SaveDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports